<template>
	<div>
	<lcsj-dialog v-model="showDialog" title="门店库存调拨" width="80%" @close="closeDialog" cancel-text="关闭" confirm-text="确认调拨" :confirm-loading="loading" @confirm="confirmTransfer">
		<div class="item_info border_Green">
			<el-descriptions class="margin-top" title="调拨门店" :column="2" border>
				<el-descriptions-item label="调出门店">
					<el-select v-model="editForm.outStoreKeyId" placeholder="请选择门店" clearable filterable disabled size="small">
						<el-option v-for="item in transferOutStoreList" :key="item.keyId" :label="item.value" :value="item.keyId"></el-option>
					</el-select>
				</el-descriptions-item>
				<el-descriptions-item label="调入门店">
					<el-select v-model="editForm.inStoreKeyId" placeholder="请选择门店" clearable filterable size="small">
						<el-option v-for="item in trensferInStoreList" :key="item.keyId" :label="item.value" :value="item.keyId"></el-option>
					</el-select>
				</el-descriptions-item>
				<el-descriptions-item label="备注" :span="2"><el-input v-model="editForm.remark" placeholder="请输入备注" size="small" type="textarea" rows="2" clearable></el-input></el-descriptions-item>
			</el-descriptions>
		</div>
		<div class="item_info border_Green">
			<div class="item_title">
				<div class="title">商品信息</div>
				<div class="btnDiv"></div>
			</div>
			<el-table class="lcsj-data-table" :cell-class-name="$moneyCellClass"
				v-loading="loading"
				:data="transferProductDtlData"
				border
				stripe
				style="width: 100%; border-radius: 10px"
				:header-cell-style="{textAlign: 'center'}"
				:cell-style="{ textAlign: 'center' }"
			>
				<el-table-column prop="rowNumber" label="序号" width="60"></el-table-column>
				<el-table-column prop="productInfo.typeName" label="类型名称" width="120"></el-table-column>
				<el-table-column prop="productInfo.productName" label="商品名称"></el-table-column>
				<el-table-column prop="productInfo.specification" label="规格"></el-table-column>
				<el-table-column prop="price" label="单价(元)" width="90"></el-table-column>
				<el-table-column v-if="canSeeCost" prop="costMoney" label="成本(元)" width="90"></el-table-column>
				<el-table-column prop="quantity" label="数量" width="160">
					<template #default="scope">
						<el-input-number v-model.number="scope.row.quantity" placeholder="请输入数量" size="small" :min="1" style="text-align: center" :step="1" width="80"></el-input-number>
					</template>
				</el-table-column>
				<el-table-column prop="money" label="金额(元)" width="90">
					<template #default="scope">
						{{ scope.row.price * scope.row.quantity }}
					</template>
				</el-table-column>
				<el-table-column prop="productInfo.unit" label="单位" width="60"></el-table-column>
			</el-table>
		</div>
		
	</lcsj-dialog>
	<!-- 调拨未成功（被静默跳过）商品提示 -->
	<el-dialog :visible.sync="skipDialogVisible" :title="skipTitle" width="70%" :close-on-click-modal="false" @close="closeSkipDialog">
		<el-alert v-if="!skipSuccess" type="error" :closable="false" title="以下商品未能完成调拨，调拨单未生成"></el-alert>
		<el-alert v-else type="warning" :closable="false" title="以下商品本次未调拨，其余商品已正常生成调拨单"></el-alert>
		<el-table class="lcsj-data-table" :data="skipListData" border stripe empty-text="暂无未调拨商品" style="margin-top: 10px; width: 100%">
			<el-table-column type="index" label="序号" width="60" align="center"></el-table-column>
			<el-table-column prop="typeName" label="类型" width="120" align="center"></el-table-column>
			<el-table-column prop="productName" label="商品名称" align="center"></el-table-column>
			<el-table-column prop="specification" label="规格" align="center"></el-table-column>
			<el-table-column prop="requestQty" label="申请数量" width="100" align="center"></el-table-column>
			<el-table-column prop="reason" label="未调拨原因" align="left" min-width="320">
				<template #default="scope">
					<span style="color: var(--app-danger-text)">{{ scope.row.reason }}</span>
				</template>
			</el-table-column>
		</el-table>
		<template #footer>
			<el-button type="primary" size="small" @click="closeSkipDialog">我知道了</el-button>
		</template>
	</el-dialog>
	</div>
</template>

<script>
import costPermission from "@/utils/costPermission.js";
import { GetOrgInfoListByConfig, GetAllOrgInfoListByConfig } from "@/api/organizationalApi.js";
import { GetStoreProductList, AddTransferRecord } from "@/api/productApi.js";
export default {
	mixins: [costPermission],
	data() {
		return {
			showDialog: false,
			loading: false,
			editForm: {
				inStoreKeyId: "",
				outStoreKeyId: "",
				dtls: [],
				remark: ""
			},
			transferProductDtlData: [],
			trensferInStoreList: [],
			transferOutStoreList: [],
			transferProductKeyIdList: [],

			skipDialogVisible: false,
			skipListData: [],
			skipTitle: "",
			skipSuccess: true
		};
	},
	// 注册组件
	components: {},
	created() {

	},
	computed: {},
	methods: {
		showTransferDialog(selectedRows, outStoreKeyId) {
			this.showDialog = true;
			this.editForm.outStoreKeyId = outStoreKeyId;
			this.transferProductKeyIdList = selectedRows.map((item) => item.keyId);
			this.GetOrgInfoListByConfig();
			this.GetStoreProductList();
			this.GetAllOrgInfoListByConfig();
		},
		closeDialog() {
			this.showDialog = false;
			this.editForm = {
				transferInStoreKeyId: "",
				transferOutStoreKeyId: "",
				transferProductDtlList: []
			};
		},
		// 获取所属门店
		GetOrgInfoListByConfig() {
			const paramer = {
				key: 1
			};
			GetOrgInfoListByConfig(paramer)
				.then((res) => {
					this.transferOutStoreList = [];
					if (res.code == 1) {
						res.data.forEach((item) => {
							this.transferOutStoreList.push({
								keyId: item.keyId,
								value: item.name + "【" + item.remark2 + "】"
							});
						});
					} else {
						this.$message.error(res.msg);
					}
				})
				.catch((err) => {
					this.loading = false;
					this.$message.error("获取门店信息失败!");
				});
		},
		// 重置展示数据（打开弹窗/切换数据时清空旧内容）
		resetData() {
			this.transferProductDtlData = [];
		},
		// 获取商品信息列表
		GetStoreProductList() {
			this.resetData();
			this.loading = true;
			const paramer = {
				keyIds: this.transferProductKeyIdList
			};
			GetStoreProductList(paramer)
				.then((res) => {
					if (res.code == 1) {
						this.transferProductDtlData = res.data;
					} else {
						this.$message.error(res.msg);
					}
				})
				.catch((err) => {
					this.loading = false;
					this.$message.error("获取商品信息失败!");
				})
				.finally(() => {
					this.loading = false;
				});
		},
		// 获取所有门店
		GetAllOrgInfoListByConfig() {
			const paramer = {
				key: 1
			};
			GetAllOrgInfoListByConfig(paramer)
				.then((res) => {
					this.trensferInStoreList = [];
					if (res.code == 1) {
						res.data.forEach((item) => {
							this.trensferInStoreList.push({
								keyId: item.keyId,
								value: item.name + "【" + item.remark2 + "】"
							});
						});
					} else {
						this.$message.error(res.msg);
					}
				})
				.catch((err) => {
					this.loading = false;
					this.$message.error("获取门店信息失败!");
				});
		},
		// 确认调拨
		confirmTransfer() {
			// 校验表单
			if (!this.editForm.inStoreKeyId) {
				this.$message.error("请选择调拨入门店！");
				return;
			}
			if (!this.editForm.outStoreKeyId) {
				this.$message.error("请选择调拨出门店！");
				return;
			}
			this.editForm.dtls = [];
			this.transferProductDtlData.forEach((item) => {
				this.editForm.dtls.push({
					keyId: item.productInfo.keyId,
					qty: item.quantity
				});
			});
			if (this.editForm.dtls.length == 0) {
				this.$message.error("请添加调拨商品！");
				return;
			}
			this.loading = true;
			AddTransferRecord(this.editForm)
				.then((res) => {
					const skipItems = (res.data && res.data.skipItems) ? res.data.skipItems : [];
					if (res.code == 1) {
						if (skipItems.length > 0) {
							this.skipListData = skipItems;
							this.skipTitle = `调拨成功，但有 ${skipItems.length} 种商品未调拨`;
							this.skipSuccess = true;
							this.skipDialogVisible = true;
							this.$message({ type: "warning", message: `调拨成功，但有 ${skipItems.length} 种商品因库存/档案原因未调拨` });
						} else {
							this.$message.success("调拨成功！");
							this.closeDialog();
							this.$parent.clearSelectedGoods();
						}
					} else {
						if (skipItems.length > 0) {
							this.skipListData = skipItems;
							this.skipTitle = "调拨未成功，以下商品未能调拨";
							this.skipSuccess = false;
							this.skipDialogVisible = true;
						} else {
							this.$message.error(res.msg);
						}
					}
				})
				.catch((err) => {
					this.loading = false;
					this.$message.error("调拨失败!");
				})
				.finally(() => {
					this.loading = false;
				});
		},
		// 关闭未调拨商品提示，并收起调拨弹窗、刷新父页面
		closeSkipDialog() {
			this.skipDialogVisible = false;
			this.skipListData = [];
			this.skipTitle = "";
			this.closeDialog();
			this.$parent.clearSelectedGoods();
		}
	}
};
</script>

<style scoped>
.selectContent {
	margin-top: 20rpx;
	display: flex;
	justify-content: center;
	align-items: center;
}

.item_info {
	border-left: 5px solid var(--app-primary-hover);
	padding: 5px 10px;
	border-radius: 5px;
	margin-bottom: 15px;
	border-bottom: 2px solid var(--app-border);
}

.border_Green {
	border-left: 5px solid var(--app-success);
}
</style>
